import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 9C2 8.17157 2.67157 7.5 3.5 7.5C4.32843 7.5 5 8.17157 5 9C5 9.82843 4.32843 10.5 3.5 10.5C2.67157 10.5 2 9.82843 2 9ZM8 9C8 8.17157 8.67157 7.5 9.5 7.5C10.3284 7.5 11 8.17157 11 9C11 9.82843 10.3284 10.5 9.5 10.5C8.67157 10.5 8 9.82843 8 9ZM14 9C14 8.17157 14.6716 7.5 15.5 7.5C16.3284 7.5 17 8.17157 17 9C17 9.82843 16.3284 10.5 15.5 10.5C14.6716 10.5 14 9.82843 14 9Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }